import { isValidPhoneNumber } from 'libphonenumber-js';
import * as yup from 'yup';

export const prescriptionValidationSchema = yup.object({
  drug: yup.string().required('Drug is required'),
  sig: yup.string().required('Sig is required'),
  prescription_date: yup.string().required('Prescription date is required'),
  dispense: yup.string().required('Dispense is required'),
  refills: yup.string().required('Refills is required'),
  // Pharmacy validation
  pharmacy_name: yup.string().required('Pharmacy name is required'),
  pharmacy_street_address: yup.string().required('Street address is required'),
  pharmacy_city: yup.string().required('City is required'),
  pharmacy_state: yup.string().required('State is required'),
  pharmacy_zip_code: yup
    .string()
    .required('Zip code is required')
    .matches(/^\d{5}(-\d{4})?$/, 'Zip code must be valid'),
  pharmacy_phone_number: yup
    .string()
    .required('Phone number is required')
    .test('is-valid-phone', 'Invalid pharmacy phone number', (value) =>
      value ? isValidPhoneNumber(value, { defaultCountry: 'US' }) : true,
    ),
});
